module.exports = __webpack_public_path__ + "static/SLCSlopes-841cfdebbcde582deaa2c1e180e3c7ec.jpg";